import { api } from "./api";

export interface CrmSettings {
  ariregisterUsername: string;
  ariregisterPasswordSet: boolean;
  source: "db" | "env" | "none";
}

/** Why a connection test failed. Mirrors the server's `AriregTestResponse`. */
export type AriregisterTestError =
  | "not_configured"
  | "auth_failed"
  | "soap_fault"
  | "http_error"
  | "timeout"
  | "network";

export interface AriregisterTestResult {
  ok: boolean;
  error?: AriregisterTestError;
  /** RIK's own words, when it had any - the fault text or the HTTP status. */
  detail?: string;
  /** The company RIK answered with, when the response could be read. */
  companyName?: string;
  /** The company the test asked about. */
  regCode?: string;
  /** Which RIK host answered. */
  endpoint?: string;
  /** Round trip in milliseconds. */
  ms?: number;
  /** Whether the form's own values were tested, or the saved ones. */
  credentials?: "form" | "stored" | "mixed";
}

export const getCrmSettings = (): Promise<CrmSettings> =>
  api.get<CrmSettings>("/admin/crm/settings");

export const saveCrmSettings = (body: {
  ariregisterUsername: string;
  ariregisterPassword: string;
}): Promise<{ ok: boolean }> =>
  api.put("/admin/crm/settings", body);

/**
 * One real RIK call with the given credentials.
 *
 * Pass what is in the form so an operator can check a password BEFORE saving
 * it over a working one; leave the fields out to test what is already stored.
 */
export const testAriregisterConnection = (body: {
  ariregisterUsername?: string;
  ariregisterPassword?: string;
} = {}): Promise<AriregisterTestResult> =>
  api.post("/admin/crm/settings/ariregister/test", body);
